var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"cmr-button",on:{"click":function($event){return _vm.$router.push(_vm.path)}}},[_c('div',{staticClass:"left-arrow"},[_c('svg-icon',{attrs:{"iconClass":"button-right-arrow"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }